import { useLayoutEffect } from 'react';

function useScrollToElement(ref: React.RefObject<HTMLElement>, condition: boolean) {
  useLayoutEffect(() => {
    if (!condition || !ref.current) return;

    const element = ref.current;

    let scrollableParent: HTMLElement | null = element;
    while (scrollableParent && scrollableParent !== document.body) {
      const style = getComputedStyle(scrollableParent);
      if (style.overflowY === 'auto' || style.overflowY === 'scroll') {
        break;
      }
      scrollableParent = scrollableParent.parentElement;
    }

    if (!scrollableParent || scrollableParent === document.body) return;

    const elementRect = element.getBoundingClientRect();
    const scrollableRect = scrollableParent.getBoundingClientRect();
    const scrollOffset = scrollableParent.scrollTop + (elementRect.top - scrollableRect.top);

    const timeout = setTimeout(() => {
      if (scrollableParent) {
        scrollableParent.scrollTo({ top: scrollOffset, behavior: 'smooth' });
      }
    }, 300);

    return () => clearTimeout(timeout);

  }, [ref, condition]);
}

export default useScrollToElement;
